import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue';
	import { useSettings } from '@/store/store';

	const logoLightUrl = '/img/logo.svg';
	const logoDarkUrl = '/img/logo-dark.svg';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
		theme: {
			type: String,
			default: '',
			validator(value: string) {
				return ['light', 'dark', ''].includes(value);
			},
		},
		global: {
			type: Boolean,
			default: false,
		},
	},
  setup(__props) {

	const settings = useSettings();

	const props = __props;

	const setTheme = computed(() => {
		let theme = props.theme;
		if (theme === '') {
			theme = settings.getActiveTheme;
		}
		return theme;
	});

	const logo = computed(() => {
		let url = logoLightUrl;
		if (setTheme.value === 'dark') {
			url = logoDarkUrl;
		}

		//@ts-ignore
		if (typeof _env.TIMESTAMP !== 'undefined') {
			// @ts-ignore
			url += '?' + _env.TIMESTAMP;
		}

		if (props.global) {
			url = '/client' + url;
		}

		return url;
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    alt: "PubHubs",
    src: logo.value
  }, null, 8, _hoisted_1))
}
}

})